module.exports = __webpack_public_path__ + "static/media/001.57527525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/001.jpg
// module id = 298
// module chunks = 0